module.exports = __webpack_public_path__ + "./han-illustration_937e2250125329f487e2eed5709d04b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2015/han-illustration.png
// module id = 420
// module chunks = 0